"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ready = exports.HaveMetadata = exports.Attached = exports.Detached = exports.HostGroup = void 0;
const state_flow_1 = require("@video/state-flow");
const state_flow_2 = require("../state-flow");
//#endregion
//#region Group Declaration
exports.HostGroup = state_flow_2.PlayerStateFlow.registerGroup("host").bootstrap(() => {
    return (0, exports.Detached)({ element: null });
});
//#endregion
//#region Signals Handlers
function hostElementAttach({ host }, signal) {
    if (typeof signal.host == null || typeof signal.host !== "object") {
        return state_flow_1.Result.reject(`Invalid host element: ${String(signal.host)}`);
    }
    return (0, exports.Attached)({ ...host, element: signal.host });
}
function hostElementDetach({ host }, signal) {
    return (0, exports.Detached)({ ...host, element: null });
}
//#endregion
//#region States Declarations
// Detached state is applied when the host element is not attached to the PlayerAPI.
exports.Detached = exports.HostGroup.registerState("Detached", {
    hostElementAttach,
});
exports.Attached = exports.HostGroup.registerState("Attached", {
    hostElementDetach,
    hostElementAttach: () => state_flow_1.Result.reject("host is already attached"),
});
exports.HaveMetadata = exports.HostGroup.registerState("HaveMetadata", {});
exports.Ready = exports.HostGroup.registerState("Ready", {});
//#endregion
//# sourceMappingURL=host.js.map